<template>
  <a-card class="todo-container" :bordered="false" :body-style="{padding: '10px'}" :title="$t('message.views.workbench.toReplenishment')" :locale="{emptyText:'暂无补货数据'}">
    <a-table :columns="toReplenishColumn" :data-source="replenishmentData" size="small" :pagination="{pageSize:5}">
      <a slot="action" slot-scope="text,record" @click="doInbound(record)">{{$t('message.views.workbench.inbound')}}</a>
    </a-table>
  </a-card>
</template>

<script>
import request from '../../../utils/request'
export default {
  name: 'ToReplenish',
  computed: {
    toReplenishColumn () {
      return [{
        title: this.$t('message.views.workbench.shopName'),
        dataIndex: 'shopName',
        width: '40%',
        ellipsis: true
      }, {
        title: this.$t('message.views.workbench.warehouse'),
        dataIndex: 'storeCode',
        width: '30%',
        ellipsis: true
      }, {
        align: 'right',
        dataIndex: 'skuNum',
        title: this.$t('message.views.workbench.skuNum'),
        width: '20%',
        ellipsis: true
      }, {
        align: 'center',
        width: 100,
        key: 'action',
        title: this.$t('message.views.workbench.operation'),
        scopedSlots: {customRender: 'action'},
        ellipsis: true
      }]
    },
    replenishmentData () {
      let res = []
      for (let sellerId in this.replenishmentMap) {
        for (let storeCode in this.replenishmentMap[sellerId]) {
          res.push({
            sellerId: sellerId,
            shopName: this.shopNameMap[sellerId],
            storeCode: storeCode,
            skuNum: this.replenishmentMap[sellerId][storeCode].skus,
            orderIds: Array.from(new Set(this.replenishmentMap[sellerId][storeCode].orderIds))
          })
        }
      }
      return res
    }
  },
  data () {
    return {
      lzdShopsIds: [],
      replenishmentMap: {},
      shopNameMap: {}
    }
  },
  mounted () {
    this.getAuthorizedLzdShops()
  },
  methods: {
    getAuthorizedLzdShops () {
      request({
        url: '/shipper/shopInfo',
        method: 'get'
      }).then(response => {
        this.lzdShopsIds = response.data.data.filter((item) => item.platform === 'LAZADA').map((item) => item.sellerId)
        let shopNameMap = {}
        for (let shop of response.data.data) {
          shopNameMap[shop.sellerId.toString()] = shop.shopName
        }
        this.shopNameMap = shopNameMap
        this.getReplenishmentData()
      })
    },
    getReplenishmentData () {
      for (let sellerId of this.lzdShopsIds) {
        request({
          url: '/inboundOrder/queryReplenishmentPlan',
          method: 'post',
          data: {
            sellerId: sellerId,
            status: 4,
            pageIndex: 1,
            pageSize: 1000
          }
        }).then(response => {
          let result = Object.assign({}, this.replenishmentMap)
          let resMap = {}
          for (let item of response.data.model) {
            if (resMap[item.destinationCode]) {
              resMap[item.destinationCode].skus = resMap[item.destinationCode].skus + 1
              resMap[item.destinationCode].orderIds.push(item.replOrderNo)
            } else {
              let orderIds = []
              orderIds.push(item.replOrderNo)
              resMap[item.destinationCode] = {
                skus: 1,
                orderIds: orderIds
              }
            }
          }
          result[sellerId.toString()] = resMap
          this.replenishmentMap = result
        })
      }
    },
    doInbound (record) {
      this.$router.push({
        name: 'inboundPlanDetail',
        query: {
          inboundPlanDetailData: {
            shopId: record.sellerId,
            warehouseId: record.storeCode,
            replenishSelected: record.orderIds
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/components/ToReplenish.vue